import { Row, Col } from "react-bootstrap";
import ownerImg from "../../assets/img/owner.jpg";
import { PageSection } from "../PageSection";
import { DecorativeRow } from "../DecorativeRow";

export const About = () => (
  <PageSection className="about" id="about">
    <DecorativeRow />

    <div className="about-content">
      <Row className="align-items-center">
        <Col lg={5} md={12} className="about-image-col">
          <div className="about-image-wrapper">
            <img src={ownerImg} alt="Chef D. Alice" />
          </div>
        </Col>

        <Col lg={7} md={12} className="about-text-col">
          <h1><span className="tagline">About Us</span></h1>

          <div className="about-story">
            <p className="intro">Hi, I'm <strong>Chef D. Alice</strong>.</p>

            <p>I am the co-owner of The Lil Bougie Foodie LLC, a mobile food truck based in Birmingham, AL. Our menu caters to your tastebuds and includes delicious spices and flavors from my birth island Jamaica. We use the freshest ingredients in all our meals to ensure you are getting the best quality taste and food for your buck!</p>

            <p>I've always loved to entertain my family and guests at my home, and cooking is one of the best things I do. After battling with a brain tumor in March of 2020 and not being able to eat for months, I started researching different cultures of foods and seasoning.</p>

            <p>I later decided I wanted to open a mobile food truck to give my friends and family a little taste of the island mixed with the American food culture, and thus <strong>The Lil Bougie Foodie</strong> was born!</p>
          </div>
        </Col>
      </Row>
    </div>

    <DecorativeRow position="bottom" />
  </PageSection>
);
